import { Status } from '@/types'

export const STATUS_TO_DISPLAY_NAME: Record<Status, string> = {
  [Status.Draft]: 'Draft',
  [Status.InReview]: 'In Review',
  [Status.Approved]: 'Approved',
  [Status.Published]: 'Published',
  [Status.Archived]: 'Archived',
}
